import axios from "axios";
import AuthService, { TOKEN } from "./AuthService";

const apiUrl = process.env.REACT_APP_API_BASE_URL;
const api = axios.create({
  baseURL: apiUrl,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      [403, 401, 400, 500].includes(error.response.status)
    ) {
      if (
        ["Token non fourni ou invalide", "Token is expired"].includes(
          error.response.data.message
        )
      ) {
        localStorage.removeItem(TOKEN);
        AuthService.logOut();
        AuthService.loginPage();
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      AuthService.logOut();
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
